export class EventService {

  static async fetchEvent(id) {
    const apiUrl = `https://physaro-forms-fn.azurewebsites.net/api/get-campaign-info/${id}`;

    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        console.error(`Error fetching event ${id}: ${response.statusText}`);
        return null; 
      }

      const data = await response.json();
      
      const ageDisclaimer = data?.data?.siteInfo?.AGE_DISCLAIMER ?? "";
      const ageMatch = String(ageDisclaimer).match(/(\d+)/);
      const minimumAge = ageMatch ? Number(ageMatch[1]) : null;

      const event = {
        dates: data.data.campaignAnimations || [],
        locationName: data.data.siteInfo.NOM || "",
        locationZip: data.data.siteInfo.CP || "",
        locationStreet: data.data.siteInfo.ADRESSE || "",
        locationCityName: data.data.siteInfo.VILLE || "",
        minimumAge,
        gifts: []
      };

      return event;

    } catch (error) {
      console.error(`Failed to fetch or parse event ${id}:`, error);
      return null;
    }
  }
}

